export interface Props {
  trade?: string;
  entity?: string;
  onRevaluationComplete?: () => void;
}

export type RevalueTradesMetricsRequestPayload = {
  start_date: string;
  end_date: string;
  trades?: number[];
  company_entity_id?: string;
  hedging_instruments?: number[];
};

export type RevalueTradesMetricsSuccessPayload = {
  task_id?: string;
};

export type TaskProgressSuccessPayload = {
  current_count: number;
  total_count: number;
  status: string;
  state: string;
  statistic: {
    created_at: string;
    finished_at: string;
    duration: string;
    error?: string;
  };
};

export interface ReportDownloadSuccessPayload {
  download_url: string;
}

/** Run type discriminator returned by (and accepted as a filter for) the task listing endpoint. */
export enum RevalueType {
  VALUE_AND_METRICS = 'VALUE_AND_METRICS',
  BCVA = 'BCVA',
}

export type ListTasksParams = {
  /** Only in-flight runs (queued/created/running). Defaults to true on the backend. */
  active?: boolean;
  revalue_type?: RevalueType;
  limit?: number;
};

export type CancelAllTasksParams = {
  /** Scope the cancel to one run type. Omit to cancel all of the user's runs. */
  revalue_type?: RevalueType;
};

export type CancelAllTasksResult = {
  cancelled_count: number;
  cancelled_task_ids: string[];
};

/** One entry from `GET /v2/admin/tasks/`. */
export type BackgroundTask = {
  task_id: string;
  status: string;
  current_count: number;
  total_count: number;
  state: string;
  revalue_type: RevalueType | string;
  run_params: {
    start_date: string | null;
    end_date: string | null;
    trades: number[] | null;
    company_entity_id: string | null;
    hedging_instruments: number[] | null;
  };
  statistic: {
    created_at: string;
    finished_at?: string;
    duration: string;
    error?: string;
  };
  created_at: string;
  updated_at: string;
};
